import {BaseWidgetProps} from '../../widget-container';
import * as React from 'react';
import {Icon, iconsMap} from '../../../common/icons/icon.comp';
import {NavigationState} from '../../../common/navigator';

export interface BreadcrumbsProps {
	categoryId: string;
	baseConfig: BaseWidgetProps;
	linkToCurrentCategory?: boolean;
}

export class Breadcrumbs extends React.Component<BreadcrumbsProps, any> {

	goToHomePage = () => {
		this.props.baseConfig.widgetNavigator.goToState(NavigationState.kb, {});
	}

	goToCategory = (categoryId: string) => {
		this.props.baseConfig.widgetNavigator.goToState(NavigationState.category, categoryId, true);
	}

	render () {
		const categoryId = this.props.categoryId;
		const category = this.props.baseConfig.categoryMap[categoryId];
		// temp fix
		if (!category) {
			return null;
		}
		// end temp fix
		const parentCategoryId = category.parentId;
		const parentCategory = this.props.baseConfig.categoryMap[parentCategoryId];
		const linkCategory = this.props.linkToCurrentCategory || !parentCategory && !category.children;

		const categoryComp = linkCategory ?
			(
				<span className='current-category category-name category-link' onClick={() => this.goToCategory(categoryId)}>
					{category.name}
				</span>
			) :
			(
				<span className={'current-category category-name'}>
					{category.name}
				</span>
			);

		const parentCategoryComp = parentCategory ?
			(
				<span className='parent-category category-name category-link' onClick={() => this.goToCategory(parentCategoryId)}>
					{parentCategory.name}
				</span>
			) : null;

		return (
			<div className={'breadcrumbs'}>
				<a className='home-link' onClick={this.goToHomePage}>
					<Icon icon={iconsMap.home} />
				</a>
				{parentCategoryComp}
				{categoryComp}
			</div>
		);
	}
}
